import { findPreposition } from '@is24at/react-transformers';
import { DEFAULT_SPOT } from '@is24at/react-constants';

export const PREPOSITION_PLACEHOLDER = 'preposition';

class SeoRules {
  templates: any;

  constructor(...templates: any[]) {
    this.templates = templates;
    Object.freeze(this);
  }

  lookupAndFormatFor(
    seoMetaType: any,
    { region, spot = DEFAULT_SPOT }: any = {},
  ) {
    const preposition = findPreposition(region);

    return this.templates
      .find(({ type }: any) => type === seoMetaType)
      .format({
        spot,
        [PREPOSITION_PLACEHOLDER]: preposition,
      });
  }
}

export default SeoRules;
